import Vue from 'vue'

// Dinamic Inputs
Vue.component('dinamic-test-input', require('./DinamicTestInput').default);
Vue.component('dinamic-test-input-array', require('./DinamicTestInputArray').default);

// Energy Code 2016
require('./2016/v1/Index')

// Energy Code 2019
require('./2019/v1/Index')

// Energy Code 2022
require('./2022/v1/Index')
